(function () {
    'use strict';

    angular.module("imApp").factory("orderFormService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3547,
                    parameters: parms || {}
                });
            },
            addToOrderItems: function (items) {
                return $ihttp.post({
                    method: 3549,
                    parameters: items
                });
            }
        };

        return service;
    }]);
})();
